class Controller {
  constructor($injector) {
    "ngInject";
    this.Events = $injector.get("Events");
  }
  $onInit() {
    this.selectedColors = (colorObject) => {
      const { r, g, b, a } = colorObject[this.name];
      this.r = r;
      this.g = g;
      this.b = b;
      this.a = a;
    };
    this.enableField = () => {
      this.editOn = !this.editOn;
    };
    this.submitField = () => {
      this.editOn = !this.editOn;
      const method = this.resourceMethod;
      const methodName = this.resourceMethodName;

      const option = {
        r: this.r,
        g: this.g,
        b: this.b,
        a: this.a,
      };
      const key = this.name;
      const result = { key, method, methodName, value: option };
      this.Events.emit(this.eventName, result);
    };
    this.Events.on(this.colorsFetchedEvent, this.selectedColors);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/colorPicker/colorPicker.controller.js